import { z } from '@faceup/validation'
import { selectFormItemTypes, textFormItemTypes } from '../constants'
import { FormItemType } from '../enums'
import { Language } from '../localization'

export const translationsJsonSchema = z.partialRecord(z.enum(Language), z.string())

export const textAnswerSchema = z.object({
  type: z.enum([...textFormItemTypes, FormItemType.OrganizationalUnit]),
  label: translationsJsonSchema,
  text_answer: z.string(),
})

export const selectAnswerSchema = z.object({
  type: z.enum([...selectFormItemTypes, FormItemType.Category]),
  label: translationsJsonSchema,
  selected_options: z.array(translationsJsonSchema),
})

export const attachmentId = z.number().brand('AttachmentId')

export const fileAnswerAttachmentSchema = z.object({
  /** Used to find and fetch the reuploaded attachment */
  originalAttachmentId: attachmentId,
  filename: z.string(),
  mimetype: z.string(),
})

export const fileAnswerSchema = z.object({
  type: z.literal(FormItemType.File),
  label: translationsJsonSchema,
  attachments: z.array(fileAnswerAttachmentSchema),
})

export const moreInfoAnswerSchema = z.object({
  type: z.literal(FormItemType.MoreInformation),
  label: translationsJsonSchema,
  text_answer: z.string(),
  voiceAttachments: z.array(fileAnswerAttachmentSchema).optional(),
})

export const encryptedMoreInfoAnswerSchema = z.object({
  type: z.literal(FormItemType.MoreInformation),
  label: translationsJsonSchema,
  body: z.string(),
  bodyNonce: z.string(),
  voiceAttachments: z.array(fileAnswerAttachmentSchema).optional(),
})

export const answerSnapshotSchema = z.discriminatedUnion('type', [
  textAnswerSchema,
  selectAnswerSchema,
  fileAnswerSchema,
  moreInfoAnswerSchema,
])

export const encryptedAnswerSnapshotSchema = z.discriminatedUnion('type', [
  textAnswerSchema,
  selectAnswerSchema,
  fileAnswerSchema,
  encryptedMoreInfoAnswerSchema,
])

export const caseSnapshotSchema = z.object({
  version: z.literal(1), // Increment version when schema changes
  answers: z.array(answerSnapshotSchema),
  attachments: z.array(fileAnswerAttachmentSchema),
})

export const encryptedCaseSnapshotSchema = z.object({
  answers: z.array(encryptedAnswerSnapshotSchema),
  attachments: z.array(fileAnswerAttachmentSchema),
})

export const attachmentTransferSchema = z.object({
  originalAttachmentId: attachmentId,
  // Trusted system-generated presigned URLs - not user input, so no URL validation.
  downloadUrl: z.string(),
  uploadUrl: z.string(),
  tempKey: z.string(),
  filename: z.string(),
  mimetype: z.string(),
})
